import React from 'react';
import { injectIntl } from 'react-intl';
import { i18nIntl } from '../../../lib/ep';
import { SquaredButton } from '../../builder/ActionButton';

const ParticipationStatus = (_status) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	let status_message = false;
	let status_icon = false;
	let status_color = 'blue';

	switch(_status) {
		case '0':
			// Pending
			status_message = `${i18n("Status")}: ${i18n("pending", 'ucfirst')}`;
			status_icon = 'knk-annonymous-users';
			status_color = 'orange';
			break;

		case '2':
			// Processing
			status_message = i18n("This entry is still being processed");
			status_icon = 'knk-loading';
			break;

		case '3':
			// Error
			status_message = i18n("Entry error: Some video could not be processed");
			status_icon = 'knk-alert';
			status_color = 'red';
			break;

		case '4':
			// Rejected
			status_message = `${i18n("Status")}: ${i18n("Rejected")}`;
			status_icon = 'knk-blocked';
			status_color = 'black';
			break;

		case '1':
			// Accepted
			/*status_message = i18n("Status") + ": " + i18n("Accepted");
			status_icon = 'knk-on';
			status_color = 'green';*/
			break;

		default:
			break;
	}

	if(status_message === false) return null;

	return (
		<SquaredButton
			color={false}
			icon={status_icon}
			_class={{ other:`${status_color}Bg whiteIcon not_link_type` }}
			tooltip={<Tooltip
				with_icon={false}
				position="top"
			>{status_message}</Tooltip>}
			aria-label="View status"
		/>
	)
};

export default injectIntl(ParticipationStatus);